import { Header, HeaderContentProps, HeaderProps } from "semantic-ui-react";

type BPHeaderProps = HeaderProps & {}

export function BPHeader(props: BPHeaderProps) {
    return <Header {...props}>
        {props.children}
    </Header>;
}

type BPHeaderSubheaderProps = HeaderProps & {}

export function BPHeaderSubheader(props: BPHeaderSubheaderProps) {
    return <Header.Subheader {...props}>
        {props.children}
    </Header.Subheader>;
}

type BPHeaderContentProps = HeaderContentProps & {}

export function BPHeaderContent(props: BPHeaderContentProps) {
    return <Header.Content {...props}>
        {props.children}
    </Header.Content>;
}